import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from 'react';
import classNames from 'classnames';
import { PdfViewer } from 'components/PdfViewer';
import ResolveImage from 'components/ResolveImage';
import { Modal, Loader } from 'ncoded-component-library';
import { isPdf, isVideo, isImage } from 'utils';
import useCallbackRef from 'hooks/useCallbackRef';
import useCloseOnEscape from 'hooks/useCloseOnEscape';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import { ModalProps } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { FilePreview } from 'models/File';
import CannotPreviewInBrowser from 'components/CannotPreviewInBrowser';

import './FilePreviewModal.styles.scss';

type FilePreviewModalProps = {
  className?: string;
  isUrlFetching?: boolean;
} & FilePreview &
  ModalProps;

const FilePreviewModal: ForwardRefRenderFunction<
  OverlayRef,
  FilePreviewModalProps
> = (props, ref) => {
  const { className, url, type, isUrlFetching, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<OverlayRef>();

  const classes = classNames('file-preview-modal', className);

  useImperativeHandle(ref, () => modal, [modal]);

  const isModalOpen = modal?.openState;

  useCloseOnEscape(modal?.close, { capture: true, enabled: isModalOpen });

  return (
    <Modal className={classes} lockScroll={false} ref={modalRef} {...rest}>
      {isUrlFetching && <Loader />}

      {url &&
        (isPdf(type) ? (
          <PdfViewer url={url} />
        ) : isVideo(type) ? (
          <video src={url} controls controlsList="nodownload" />
        ) : isImage(type) ? (
          <ResolveImage src={url} />
        ) : (
          <CannotPreviewInBrowser>
            <iframe src={url} key={url} title={url} />
          </CannotPreviewInBrowser>
        ))}
    </Modal>
  );
};

export default forwardRef(FilePreviewModal);
